class LevayoNavigation extends HTMLElement {
  #controller;
  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const details = this.querySelector('details');
    const summary = details?.querySelector('summary');
    if (!details || !summary) return;
    const updateHeight = () => {
      if (!details.open) return;
      const panel = details.querySelector('.lvnav__panel');
      if (!panel) return;
      this.style.setProperty('--lvnav-panel-height', `${Math.max(120, innerHeight - panel.getBoundingClientRect().top - 16)}px`);
    };
    details.addEventListener('toggle', updateHeight, { signal });
    window.addEventListener('resize', updateHeight, { passive: true, signal });
    document.addEventListener('scroll', updateHeight, { capture: true, passive: true, signal });
    const close = (restoreFocus = false) => {
      details.open = false;
      if (restoreFocus) summary.focus();
    };
    this.querySelector('[data-nav-close]')?.addEventListener('click', () => close(true), { signal });
    details.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && details.open) {
        event.preventDefault();
        event.stopPropagation();
        close(true);
      }
    }, { signal });
    details.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !details.contains(event.relatedTarget)) close();
    }, { signal });
    document.addEventListener('pointerdown', (event) => {
      if (details.open && !details.contains(event.target)) close();
    }, { signal });
    this.addEventListener('click', (event) => {
      if (event.target.closest('a')) close();
    }, { signal });
    document.addEventListener('toggle', (event) => {
      if (event.target !== details && event.target instanceof HTMLDetailsElement && event.target.open && !details.contains(event.target)) close();
    }, { capture: true, signal });
  }
  disconnectedCallback() { this.#controller?.abort(); }
}
if (!customElements.get('levayo-navigation')) customElements.define('levayo-navigation', LevayoNavigation);
